import { combineReducers } from '@reduxjs/toolkit';
import { connectAgentReducer } from './connect';

export const appReducer = combineReducers({
  connect: connectAgentReducer,
});

export type AppState = ReturnType<typeof appReducer>;

export { connectAgentActions } from './connect';
